import { useQueries } from "react-query";
import { radReportDetailsQueryOptions } from "../../Chat/services/radReportQuery";
var useGetLinkedReportDetails = function useGetLinkedReportDetails(patientUid, reportIds) {
  var results = useQueries(reportIds.map(function (id) {
    return radReportDetailsQueryOptions(patientUid, id);
  }));
  var isLoading = results.some(function (r) {
    return r.isLoading;
  });
  var reportsList = results.filter(function (r) {
    var _r$data;
    return r.isSuccess && ((_r$data = r.data) === null || _r$data === void 0 ? void 0 : _r$data.success);
  }).map(function (r) {
    return r.data.data;
  });
  return {
    reportsList: reportsList,
    isLoading: isLoading
  };
};
export default useGetLinkedReportDetails;